import { useShopStore } from "@/store";
import type { RouteLocationNormalized } from "vue-router";

export function getShopId(route?: RouteLocationNormalized) {
  const shopStore = useShopStore();
  
  try {
    // 如果提供了路由对象，优先从路由查询参数中获取
    if (route?.query?.shop) {
      const shop = route.query.shop as string;
      shopStore.setShopId(shop?.split('.')[0]);
      return shop;
    }
    
    // 如果路由中没有 shop 参数，尝试从 store 中获取
    if (shopStore.shopId) {
      return shopStore.shopId.split(".")[0];
    }
    
    // 如果都没有，返回空字符串
    return "";
  } catch (error) {
    console.error('Error in getShopId:', error);
    return shopStore.shopId || "";
  }
}
